<template>
  <div class="block-actions-btn position-relative">
    <Icon
      v-if="actionBtnIcon"
      ref="actionButton"
      class="cursor-pointer py-3"
      width="18"
      :fill="$scss.secondaryTextBg"
      :name="actionBtnIcon"
      @click.native="onActionsMenuToggle"
    />
    <!-- actions button menu-->
    <PopoverMenu
      class="actions-menu"
      :position="actionsBtnPosition"
      :closest="$el"
      :float="['right']"
      :items="actionsBtnItems"
      auto-close
      :width="[0, '21rem']"
      :height="[0, '35rem']"
      @toggle="onMenuToggle"
    >
      <template v-slot="{ item }">
        <div
          class="menu-item"
          :class="{ disabled: item.disabled }"
          @click="item.handler"
        >
          <TextBlock tag="p" class="mb-3" :variant="getMenuItemVariant(item)">
            <template v-if="item.icon">
              <Icon :name="item.icon" width="18" :fill="$scss.heraMuted" />
              <span class="dummy-separator p-0 m-0 ml-2"></span>
            </template>
            <span class="my-2">
              {{
                $t(`_web_tournament_match-menu-item-${item.key}`, item.title)
              }}
            </span>
          </TextBlock>
          <TextBlock variant="secondary" :size="0.75" :text="item.subtitle" />
        </div>
      </template>
    </PopoverMenu>
  </div>
</template>

<script>
import Icon from '@/components/atoms/Icon';
import PopoverMenu from '@/components/popover/Menu';
import TextBlock from '@/components/atoms/TextBlock';
import loadingMixin from '@/mixins/isLoading';
import { prop } from '@/utils/factories';

export default {
  name: 'ActionsMenu',
  components: {
    Icon,
    PopoverMenu,
    TextBlock,
  },
  mixins: [loadingMixin],
  props: {
    actionBtnRef: prop([Node], null),
    actionBtnIcon: prop(String, 'dots'),
    actionsBtnItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      actionsBtnPosition: null,
    };
  },
  methods: {
    onActionsMenuToggle() {
      this.actionsBtnPosition =
        this.actionBtnRef || this.$refs.actionButton.$el;
    },
    onMenuToggle(isVisible) {
      if (!isVisible) {
        this.actionsBtnPosition = null;
      }
    },
    getMenuItemVariant(item) {
      return item.disabled ? 'muted' : item.variant || 'primary';
    },
  },
};
</script>

<style lang="scss">
.block-actions-btn {
  .dropbox-menu {
    width: 365px;
    padding: $ph-large-space;
    .menu-item {
      padding: $ph-medium-space;
      border: 1px solid $ph-secondary-text;
      border-radius: $ph-medium-radius;
      white-space: normal;
      line-height: 1;
    }
    li:not(:last-child) .menu-item {
      margin-bottom: $ph-medium-space;
    }
  }
}
</style>
